import { MedicationOutlined as MedicationOutlinedIcon, PostAddOutlined as PostAddOutlinedIcon } from "@mui/icons-material";
import { useAuth } from "../../../auth/context";

export const prescriptionDocumentType = {
  name: "receta",
  title: "Receta",
  basePath: "prescriptions",
  Icon: MedicationOutlinedIcon,
};

export const orderDocumentType = {
  name: "orden",
  title: "Orden",
  basePath: "orders",
  Icon: PostAddOutlinedIcon,
};

export const documentTypes = [prescriptionDocumentType, orderDocumentType];

export const newDocumentPath = ({ basePath }) => `/${basePath}/new`;

export const useCreatableDocumentTypes = (candidates = documentTypes) => {
  const { user } = useAuth();
  return candidates.filter(({ basePath }) => user.can("create", basePath));
};
